const mapboxMapConfig = {
  accessToken: window.Transwest.mapboxAccessToken,
  // Options: https://docs.mapbox.com/api/maps/mapbox-styles
  style: 'mapbox://styles/mapbox/streets-v11',
  fitBoundsOptions: {
    padding: {
      top: 20,
      left: 20,
      right: 20,
      bottom: 20,
    },
  },
  AnimationOptions: {
    animate: false,
  },
  PaddingOptions: {
    top: 20,
    left: 20,
    right: 20,
    bottom: 20,
  },
  dragRotate: false,
  center: [-96.369543, 44.406463],
  maxZoom: 17,
};

const cdnUrl = 'https://d1enjtqb0dhyoj.cloudfront.net/uploads/shared/icons';

const pinIconUrl = `${cdnUrl}/map-pin.svg`;
const userIconUrl = `${cdnUrl}/circle-pin-blue.svg`;

const pinStyles = {
  userIcon: {
    backgroundImage: `url(${userIconUrl})`,
    backgroundSize: 'contain',
    width: '23px',
    height: '23px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
  },
  pinIcon: {
    backgroundImage: `url(${pinIconUrl})`,
    backgroundSize: 'contain',
    width: '25px',
    height: '37px',
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
  },
};

export { mapboxMapConfig, pinStyles };
